<template>
    <div
        :class="{
            connect: dataStatus.kode === 1,
            notConnect: dataStatus.kode === 0,
            confirm: dataStatus.kode === 2,
            warning: dataStatus.kode === 3 || dataStatus.kode === 4,
        }"
    >
        <div class="d-flex-between-center p-x-20 p-y-8">
            <div>
                <IconBased width="16" height="16" v-if="dataStatus.kode === 1">
                    <template v-slot:icons>
                        <Online />
                    </template>
                </IconBased>
                <IconBased width="12" height="12" v-if="dataStatus.kode === 2">
                    <template v-slot:icons>
                        <WarningCircle />
                    </template>
                </IconBased>
                <IconBased width="12" height="12" v-if="dataStatus.kode === 3 || dataStatus.kode === 4">
                    <template v-slot:icons>
                        <WarningTriangle />
                    </template>
                </IconBased>
                <IconBased width="12" height="12" v-if="dataStatus.kode === 0">
                    <template v-slot:icons>
                        <InfoSquare />
                    </template>
                </IconBased>
                {{ dataStatus.status }}
            </div>
            <div @click="gotoDetail" v-if="dataStatus.kode === 0 || dataStatus.kode === 4 || dataStatus.kode === 2 && validateAccess('whatsappDevice.update')">
                <label class="m-d-0 f-c-blue m-r-8">{{ getLinkText }}</label>
                <IconBased width="9" height="8">
                    <template v-slot:icons>
                        <NextStep2Blue />
                    </template>
                </IconBased>
            </div>
            <div @click="gotoBeliPaket" v-if="dataStatus.kode === 3 && validateAccess('whatsappDevice.purchase  ')">
                <label class="m-d-0 f-c-blue m-r-8">Beli Paket</label>
                <IconBased width="9" height="8">
                    <template v-slot:icons>
                        <NextStep2Blue />
                    </template>
                </IconBased>
            </div>
            <div @click="gotoDiskonek" v-if="dataStatus.kode === 1 && validateAccess('whatsappDevice.update')">
                <label class="m-d-0 f-c-red m-r-8">Logout Perangkat</label>
                <IconBased width="9" height="8">
                    <template v-slot:icons>
                        <NextStep2Blue icon-fill="#EB5757" />
                    </template>
                </IconBased>
            </div>
        </div>
    </div>
</template>
<script>
import IconBased from "./iconPack/IconBased.vue";
import Online from "./iconPack/Online.vue";
import WarningCircle from "./iconPack/WarningCircle.vue";
import WarningTriangle from "./iconPack/WarningTriangle.vue";
import InfoSquare from "./iconPack/InfoSquare.vue";
import NextStep2Blue from "./iconPack/NextStep2Blue.vue";

export default {
    name: "DeviceStatus",
    props: {
        dataStatus: {
            type: Object,
            required: true,
        },
        dataMesin: {
            type: Object,
            required: true,
        },
    },
    components: {
        IconBased,
        Online,
        WarningCircle,
        WarningTriangle,
        InfoSquare,
        NextStep2Blue,
    },
    computed: {
        getLinkText() {
            return this.dataStatus.kode === 0 ? "Scan perangkat" : this.dataStatus.kode === 4 ? "Scan ulang" : "Detail";
        },
        getRouteName() {
            return this.$route.name;
        },
    },
    methods: {
        gotoBeliPaket() {
            this.$router.push({
                name: "wa_autosender.detail_perangkat.ubah_paket_1",
                params: { id_device: this.dataMesin.iddevice },
                query: { customTitle: "Beli Paket" },
            });
            this.smartTrackingClick("beli_paket_perangkat_whatsapp");
        },
        gotoDetail() {
            let goto = { name: "wa_autosender.welcome_page" };

            if (this.dataStatus.kode === 2) {
                goto = {
                    name: "wa_autosender.pembayaran",
                    params: { id_device: this.dataMesin.iddevice, id_bill: this.dataMesin.idbill },
                };
                this.smartTrackingClick("detail_tagihan_perangkat_whatsapp");
            } else {
                goto = { name: "wa_autosender.connect_perangkat", params: { id_device: this.dataMesin.iddevice } };
                this.smartTrackingClick("scan_perangkat_whatsapp");

            }

            this.$router.push(goto);
        },
        gotoDiskonek() {
            this.smartTrackingClick("logout_perangkat_whatsapp");
            switch (this.getRouteName) {
                case "wa_autosender.detail_perangkat":
                    this.$router.push({
                        name: "wa_autosender.detail_perangkat.confirm_logout",
                        params: { id_perangkat: this.dataMesin.iddevice },
                    });
                    break;
                case "wa_autosender.daftar_perangkat":
                    this.$router.push({
                        name: "wa_autosender.daftar_perangkat.confirm_logout",
                        params: { id_perangkat: this.dataMesin.iddevice },
                    });
                    break;
            }
        },
    },
};
</script>
<style scoped>
.confirm {
    background: linear-gradient(90deg, #fff8e1 0%, #ffffff 100%);
}
.connect {
    background: linear-gradient(90deg, #effaf1 0%, #ffffff 100%);
}
.warning {
    background: linear-gradient(90deg, #fef0f0 0%, #ffffff 100%);
}
.notConnect {
    border-bottom: 1px solid #ededed;
}
</style>
